// extracted by mini-css-extract-plugin
export default {"mascotContainer":"SquiggleMascot_mascotContainer__0ypdM","sprite":"SquiggleMascot_sprite__xIXrC","talking":"SquiggleMascot_talking__a9aAq","talk":"SquiggleMascot_talk__H9Ef-"};